import * as React from "react"
import request from "@/server/request"
import config, { captchaAppId } from "@/server/config"
import * as utils from "@/server/utils"
import alert from "@/pages/components/common/alert"
import "./scss/login.scss"
//require('http://www.ibuychem.com/resource/scripts/mhs_sso.js')

interface initProps {
  history: any
}

class Login extends React.Component<initProps, any> {
  private needRecordActivity: boolean = false
  constructor(props: any) {
    super(props)
    this.state = {
      login_way: "code",
      form: {
        username: "",
        password: "",
        code: "",
        loginMode: 2,
        autoLogin: 1,
        agreement: 1,
        loginSys: 2,
        returnUrl: this.getOuthBackUrl(),
      },
      imgCode: "",
      captchakey: "", // 验证码随机数
      captchaUrl: "", // 图形验证码地址
      timer: "", // 定时器
      timerNumber: 60, //
      isOpenTimer: true,
      // 0 PC会员注册；10 移动版注册；11 报价通注册；12 专家库注册；13 移动版注册(买家部)；默认10，移动版注册
      sourceType: "",
      isInMiniProgram: false, // 是否在小程序中
      isInWechat: utils.getIsWxClient(), // 是否在微信中
      supplementary: false, // 是否显示补充资料
      finalUrl: "", // 各种逻辑处理后最后跳转的链接
      token: "", // 登录token
      must: utils.getQueryString("must") || "0",
      showQuickLoginPanel: true,
    }
  }

  componentDidMount() {
    // this.getGraphic()
    if ((window as any)._hmt) {
      ;(window as any)._hmt.push(["_trackPageview", "/mobile/uc/build/login"])
    }
    // 判断地址栏是否有sourceType参数
    const querySourceType = utils.getQueryString("sourceType")
    if (querySourceType) {
      this.setState({
        sourceType: querySourceType,
      })
    }
    if ((window as any).swan && (window as any).swan.webView) {
      ;(window as any).swan.webView.getEnv((res: any) => {
        if (res.smartprogram) {
          this.setState({
            isInMiniProgram: true,
          })
        }
      })
    }

    // 判断活动
    const activityUrl = this.getOuthBackUrl()
    if (
      activityUrl ===
      "https%3A%2F%2Fd.7-event.cn%2FReg%2Flogin%2Fccsf%3Ftype%3Dwechat"
    ) {
      this.needRecordActivity = true
      this.getActivityStatus(true)
    }
  }

  componentWillUnmount() {
    this.setState({
      timer: "",
    })
  }

  render() {
    if (
      !this.state.isInMiniProgram &&
      this.state.isInWechat &&
      this.state.showQuickLoginPanel
    ) {
      return (
        <div className="page-login page-login-wx">
          <div className="logo-warrper">
            <img
              src="https://cn.ibuychem.com/public/new_index/images/logo.png"
              alt=""
              className="logo"
            />
          </div>
          <div className="login-form">
            <div className="login-bottom">
              <button
                className="login-subBtn wxBtn"
                onClick={() => this.quickLoginByWechat()}
              >
                <img
                  src="https://zt.ibuychem.com/file/image/ibuychem/wx.jpg"
                  alt=""
                />
                微信一键登录
              </button>
              <button
                className="login-subBtn"
                onClick={() => this.setState({ showQuickLoginPanel: false })}
              >
                手机号一键登录
              </button>
              <div className="login-box">
                <span className="keep-pw">
                  <div className="checkbox-warrper fl">
                    <input
                      type="checkbox"
                      className="checkbox"
                      onChange={(e) =>
                        this.setForm(
                          "agreement",
                          e.target.checked === true ? 1 : 0
                        )
                      }
                      checked={this.state.form.agreement === 1}
                    />
                    <span className="checkbox-icon"></span>
                  </div>
                  <label className="law">
                    我已阅读并同意《
                    <a href="https://www.ibuychem.com/legalnotice.html">
                      买化塑用户服务协议
                    </a>
                    》《
                    <a href="https://user.hzeyun.com/mobile/build/legal">
                      慧正资讯法律声明
                    </a>
                    》
                  </label>
                </span>
              </div>
            </div>
          </div>
        </div>
      )
    }
    return (
      <div className="page-login">
        {this.state.must === "0" && (
          <a
            className="login-cancel"
            href="javascript: void(0)"
            onClick={() => this.loginCancel()}
          >
            暂不登录
          </a>
        )}
        <div className="logo-warrper">
          <img
            src={require("@/assets/images/mai_logo.png")}
            alt=""
            className="logo"
          />
        </div>
        <div className="login-form">
          <div className="login-content">
            <input
              type="text"
              placeholder="请输入手机号"
              value={this.state.form.username}
              onChange={(e: any) => this.setForm("username", e.target.value)}
              className="login-input"
            />
            {this.state.login_way === "password" ? (
              <input
                type="password"
                placeholder="请输入密码"
                value={this.state.form.password}
                onChange={(e: any) => this.setForm("password", e.target.value)}
                className="login-input"
              />
            ) : (
              ""
            )}

            {/*{
                            this.state.login_way !== 'password' ? 
                                <div className="code-warpper">
                                    <input type="text"   placeholder="请输入图形验证码" value={this.state.imgCode} onChange={ (e:any) => this.setState({ imgCode: e.target.value }) }   className="login-input" />
                                    <img src={this.state.captchaUrl} alt="" className="code-img" onClick={() => this.getGraphic()}/>
                                </div> :''
                        }*/}
            {this.state.login_way !== "password" ? (
              <div className="code-warpper">
                <input
                  type="text"
                  maxLength={6}
                  placeholder="请输入验证码"
                  value={this.state.form.code}
                  onChange={(e: any) => this.setForm("code", e.target.value)}
                  className="login-input"
                />
                <button className="code-btn" onClick={() => this.sendMessage()}>
                  {this.state.timerNumber === 60
                    ? "获取验证码"
                    : this.state.timerNumber}
                </button>
              </div>
            ) : (
              ""
            )}
          </div>
          <div className="login-bottom">
            <div className="login-box">
              <span className="keep-pw">
                <div className="checkbox-warrper">
                  <input
                    type="checkbox"
                    className="checkbox"
                    onChange={(e) =>
                      this.setForm(
                        "autoLogin",
                        e.target.checked === true ? 1 : 0
                      )
                    }
                    checked={this.state.form.autoLogin === 1}
                  />
                  <span className="checkbox-icon"></span>
                </div>
                <label>自动登录</label>
              </span>
              {this.state.login_way !== "code" ? (
                <span
                  className="forget-pw font-link"
                  onClick={() =>
                    this.props.history.push(
                      `/forget_password?returnUrl=${this.getOuthBackUrl()}&sourceType=${
                        this.state.sourceType
                      }`
                    )
                  }
                >
                  忘记密码？
                </span>
              ) : null}
            </div>
            {this.state.login_way === "code" ? (
              <div className="login-box">
                <span className="keep-pw">
                  <div className="checkbox-warrper">
                    <input
                      type="checkbox"
                      className="checkbox"
                      onChange={(e) =>
                        this.setForm(
                          "agreement",
                          e.target.checked === true ? 1 : 0
                        )
                      }
                      checked={this.state.form.agreement === 1}
                    />
                    <span className="checkbox-icon"></span>
                  </div>
                  <label className="law">
                    同意《
                    <a href="https://www.ibuychem.com/legalnotice.html">
                      买化塑用户服务协议
                    </a>
                    》《
                    <a href="https://user.hzeyun.com/mobile/build/legal">
                      慧正资讯法律声明
                    </a>
                    》
                  </label>
                </span>
              </div>
            ) : null}
            <button className="login-subBtn" onClick={() => this.submitForm()}>
              登录
            </button>
            <p className="bottom-font">
              <span
                className="font-link fr"
                onClick={() =>
                  this.changeLoginWay(
                    this.state.login_way === "code" ? "password" : "code"
                  )
                }
              >
                {this.state.login_way !== "code" ? "验证码登录" : "密码登录"}
              </span>
            </p>
          </div>
        </div>
        {this.state.supplementary && (
          <div className="receiveCon-wrapper">
            <div className="receiveCon">
              <span
                className="close"
                onClick={() => this.supplementaryVisible(false)}
              ></span>
              <div className="receivetop">
                <h3>提示</h3>
              </div>
              <div className="receivebtm">
                <p>产业研报领取</p>
                <button
                  className="receiveBtn"
                  onClick={() => this.goToSupplementary()}
                >
                  去领取
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    )
  }

  private async toWXAuth() {
    const returnUrl = encodeURIComponent(
      encodeURIComponent(window.location.origin + "/mobile/uc/build")
    )
    window.location.href = `${
      config.WAPAPI
    }login/wechat/auth?scope=2&userType=3&returnUrl=${returnUrl}&businessUrl=${this.getSupplementary()}`
  }

  private getOuthBackUrl() {
    const returnUrl = GetQueryString("returnUrl")

    function GetQueryString(name: any) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)")
      var r = window.location.search.substr(1).match(reg)
      if (r != null) return unescape(r[2])
      return null
    }
    if (returnUrl) {
      return returnUrl ? encodeURIComponent(returnUrl) : ""
    } else {
      return encodeURIComponent(
        encodeURIComponent(window.location.origin + "/mobile/uc/build")
      )
    }
  }

  // 发送短信
  private sendMessage() {
    const that = this
    if (!this.state.isOpenTimer) {
      return
    }

    if (this.state.form.username.replace(/\s/gi, "") === "") {
      alert.open({
        promptText: "请输入手机号",
      })
      return
    }

    // 定义回调函数
    function callback(res: any) {
      // 第一个参数传入回调结果，结果如下：
      // ret         Int       验证结果，0：验证成功。2：用户主动关闭验证码。
      // ticket      String    验证成功的票据，当且仅当 ret = 0 时 ticket 有值。
      // CaptchaAppId       String    验证码应用ID。
      // bizState    Any       自定义透传参数。
      // randstr     String    本次验证的随机串，后续票据校验时需传递该参数。
      // verifyDuration     Int   验证码校验接口耗时（ms）。
      // actionDuration     Int   操作校验成功耗时（用户动作+校验完成）(ms)。
      // sid     String   链路sid。
      // res（用户主动关闭验证码）= {ret: 2, ticket: null}
      // res（验证成功） = {ret: 0, ticket: "String", randstr: "String"}
      // res（请求验证码发生错误，验证码自动返回trerror_前缀的容灾票据） = {ret: 0, ticket: "String", randstr: "String",  errorCode: Number, errorMessage: "String"}
      // 此处代码仅为验证结果的展示示例，真实业务接入，建议基于ticket和errorCode情况做不同的业务处理
      if (typeof res.errorCode === "undefined" && res.randstr && res.ticket) {
        that.startSendSms(res.randstr, res.ticket)
      }
    }
    function loadErrorCallback() {
      var appid = captchaAppId
      var ticket =
        "trerror_1001_" + appid + "_" + Math.floor(new Date().getTime() / 1000)
      callback({
        ret: 0,
        randstr: "@" + Math.random().toString(36).substr(2),
        ticket: ticket,
        errorCode: 1001,
        errorMessage: "jsload_error",
      })
    }

    try {
      var captcha = new (window as any).TencentCaptcha(captchaAppId, callback, {
        userLanguage: "zh-cn",
        showFn: () => {},
      })
      captcha.show()
    } catch (error) {
      loadErrorCallback()
    }

    // if (this.state.imgCode.replace(/\s/gi, "") === "") {
    //   alert.open({
    //     promptText: "请输入图形验证码",
    //   })
    //   return
    // }
  }

  private startSendSms(randstr: any, ticket: string) {
    const that = this
    this.setState(
      {
        isOpenTimer: false,
      },
      () => {
        const data = request({
          method: "get",
          url: `${config.API2}sms/send`,
          data: {
            type: 3,
            mobile: this.state.form.username,
            randstr,
            ticket,
          },
        })

        data.then((r) => {
          if (r.code === 1) {
            // 如果成功 开启定时器

            that.setState({
              timer: setInterval(() => {
                if (that.state.timerNumber > 0) {
                  that.setState({
                    timerNumber: this.state.timerNumber - 1,
                  })
                } else {
                  //  重置定时器
                  clearInterval(this.state.timer)
                  // that.getGraphic()
                  that.setState({
                    isOpenTimer: true,
                    timer: "",
                    timerNumber: 60,
                  })
                }
              }, 1000),
            })
          } else {
            // that.getGraphic()
            that.setState(
              {
                isOpenTimer: true,
              },
              () => {
                alert.open({
                  promptText: r.msg,
                })
              }
            )
          }
        })
      }
    )
  }

  // 获取图形验证码
  // private getGraphic() {
  //   const text = Math.random() * Math.pow(10, 17)
  //   const url = config.WAPAPI + "captcha/image?captchakey=" + text

  //   this.setState({
  //     captchaUrl: url,
  //     captchakey: text,
  //   })
  // }

  // 表单赋值
  private setForm(name?: string, val?: any) {
    if (!name) {
      return
    }
    this.state.form[name] = val
    this.setState({
      form: {
        ...this.state.form,
      },
    })
  }

  // 切换登陆方式
  private changeLoginWay(name: string) {
    if (name === "code") {
      this.setState({
        login_way: "code",
        form: {
          ...this.state.form,
          loginMode: 2,
          username: "",
          password: "",
        },
      })
    } else {
      this.setState({
        login_way: "password",
        form: {
          ...this.state.form,
          loginMode: 1,
          username: "",
          code: "",
        },
      })
    }
  }

  // 检查表单
  private checkForm() {
    if (this.state.login_way === "code") {
      if (this.state.form.code.replace(/\s/gi, "") === "") {
        return
      }
    } else {
      if (this.state.form.password.replace(/\s/gi, "") === "") {
        return
      }
    }
    if (this.state.form.username.replace(/\s/gi, "") === "") {
      return
    }

    return true
  }

  // 提交表单
  private async submitForm() {
    const that = this
    if (!this.checkForm()) {
      return
    }

    if (this.state.login_way === "code" && this.state.form.agreement === 0) {
      return alert.open({
        promptText: "请同意《买化塑用户服务协议》《慧正资讯法律声明》",
      })
    }

    const r = await request({
      method: "post",
      url: `${config.WAPAPI}security/login`,
      data: {
        ...this.state.form,
        autoRegister: this.state.form.loginMode === 2,
      },
    })
    if (r.code !== 1) {
      alert.open({
        promptText: r.msg,
      })
    } else {
      let rurl = ""
      // 如果登陆后没有设置密码
      if (r.obj && !r.obj.pwd) {
        // 根据返回类型区分是登录 还是 登录后自动注册
        rurl =
          window.location.origin +
          "/mobile/uc/build/set_password?returnUrl=" +
          this.getOuthBackUrl()
      } else {
        rurl = `${config.HZ_PC_API}security/setLoginCookie/handler?token=${
          r.obj.token
        }&returnUrl=${that.getOuthBackUrl()}`
      }

      // 查看是否需要记录活动
      if (this.needRecordActivity) {
        await this.getActivityStatus(false)
      }

      ;(window as any).mhs_sso.setCookie(
        config.ENV === "development" ? 0 : 1,
        r.obj.token,
        () => {
          this.setState(
            {
              finalUrl: rurl,
              token: r.obj.token,
            },
            () => {
              ;(window as any).mhs_sso.locationReturnURL(
                config.ENV === "development" ? 0 : 1,
                rurl,
                r.obj.token
              )
            }
          )
        }
      )
    }
  }

  // 暂不登录
  private loginCancel() {
    ;(window as any).history.back()
  }

  /**
   * [supplementaryVisible 显示隐藏补充弹窗]
   * @param  visible 显示隐藏
   */
  private supplementaryVisible(visible: Boolean) {
    this.setState(
      {
        supplementary: visible,
      },
      () => {
        // 关闭弹窗执行原来跳转路径
        if (!visible) {
          ;(window as any).mhs_sso.locationReturnURL(
            config.ENV === "development" ? 0 : 1,
            this.state.finalUrl,
            this.state.token
          )
        }
      }
    )
  }

  private getSupplementary() {
    return this.getOuthBackUrl()
  }

  // 跳转补充资料页面
  private goToSupplementary() {
    window.location.href = this.getSupplementary()
  }

  private async getActivityStatus(autoRedirect: boolean) {
    const r = await request({
      method: "get",
      url: `${config.API}/member/info/activity/check`,
      data: {
        activityType: 3,
      },
    })

    if (r.code === 1) {
      if (!r.obj) {
        // 如果是活动进来，已经登录，并且没有记录活动，自动记录完重定向到活动页
        this.setActivityStatus(autoRedirect)
      } else {
        // 如果是活动进来，登录了，并且已经记录好，自动跳转
        if (autoRedirect)
          window.location.href = decodeURIComponent(this.getOuthBackUrl())
      }
    }
  }
  private async setActivityStatus(autoRedirect: boolean) {
    const r = await request({
      method: "get",
      url: `${config.API}/member/info/activity/save`,
      data: {
        activityType: 3,
      },
    })
    if (r.code === 1) {
      // 如果是活动进来，登录了，并且已经记录好，自动跳转
      if (autoRedirect)
        window.location.href = decodeURIComponent(this.getOuthBackUrl())
    }
  }

  private quickLoginByWechat() {
    if (this.state.form.agreement === 0) {
      return alert.open({
        promptText: "请同意《买化塑用户服务协议》《慧正资讯法律声明》",
      })
    }
    this.toWXAuth()
  }
}

export default Login
